module.exports = __webpack_public_path__ + "img/biaoqian_chuguan.e22e960b.png";